import { render, staticRenderFns } from "./ekyc-notice.vue?vue&type=template&id=cdfa6cfe&scoped=true"
import script from "./ekyc-notice.vue?vue&type=script&setup=true&lang=ts"
export * from "./ekyc-notice.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ekyc-notice.vue?vue&type=style&index=0&id=cdfa6cfe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfa6cfe",
  null
  
)

export default component.exports